module.exports = __webpack_public_path__ + "static/media/tyrone.6668063d.jpg";